'use client';
import { Breadcrumb, Container, PublicPageHeading } from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';

const Faq: React.FC = () => {
  const { t } = useTranslation('pages.faq');

  return (
    <>
      <Container>
        <Breadcrumb
          list={[
            { title: routes.home.title, href: routes.home.url },
            {
              title: routes.faq.title,
              href: routes.faq.url,
            },
          ]}
        />
      </Container>
      <PublicPageHeading title={t('faqsTitle')} />
    </>
  );
};
export default Faq;
